import React from 'react'
import '../Main/Main.css'
import Card from '../Card/Card'
import { Link, useNavigate } from 'react-router-dom'
import twinpacs from '../../assets/twinpacs.png'
import lcexten from '../../assets/lcexten.png'
import moiveApp from '../../assets/movie-app.png'
import cpunified from '../../assets/cpunified.png'

function Main() {


    const projectImages = [twinpacs, cpunified, lcexten, moiveApp];

    const experiences = [
        {
            date: "MAY 2024 - PRESENT",
            heading: "Inncircles Technologies",
            role: "Product Developer",
            description: "As a Full Stack Product Developer I Integrated SSO and maps, built analytics and messaging, led dev team and served as Scrum Master for multiple sprints.",
            keywords: ["Angular", "React Native", "MongoDB", "Nodejs", "ExpressJs", "Fastify", "NEXT", "NestJs"]
        },
        {
            date: "AUG 2023 - APR 2024",
            heading: "Inncircles Technologies",
            role: "Product Developer Intern",
            description: "Acquired hands-on experience in full stack web development, expanding technical expertise and understanding of industry best practices through real project collaboration.",
            keywords: ["Angular", "React Native", "MongoDB", "ExpressJs"]
        },
        {
            date: "MAY 2021 – JAN. 2022",
            heading: "CodeChef Student Chapter",
            role: "Competitive Programming Lead",
            description: "Leading the competitive programming activities as part of the CodeChef student chapter in my college is a significant achievement and responsibility.",
            keywords: ["Coding", "DSA", "Algorithm", "Coding Contest", "Student Chapter"]
        },
        {
            date: "2020 - 2024",
            heading: "Vignan's Institute Of Information Technology",
            role: "Engineering Student",
            description: "Studied Computer Sciemce & Engineering",
            keywords: ["B Tech", "Computer Science", "Engineering"]
        }
    ]

    const projects = [
        {
            hyperLink: "https://github.com/akashh369/twinpacs",
            link: "true",
            heading: "Twinpacs landing page",
            description: "Developed a responsive landing page for Twinpacs, a company specializing in IT solutions. Collaborated with the client to design and implement an engaging, user-friendly website that effectively communicates Twinpacs’ expertise and services in the technology sector.",
            keywords: ["Angular", "Tailwind", "Nodejs"],
        },
        {
            hyperLink: "https://github.com/akashh369/Codechef-API",
            link: "true",
            heading: "CPUnified",
            description: "Developed a web application to track and compare user statistics across multiple coding platforms, with a focus on CodeChef. Implemented real-time data scraping using Puppeteer to collect contest results and aggregate performance metrics, enabling users to visualize and benchmark their coding progress efficiently",
            keywords: ["React", "Express", "Puppeteer", "MongoDB"],
        },
        {
            hyperLink: "https://github.com/akashh369/lcexten",
            link: "true",
            heading: "LeetCode Extension",
            description: "Motivated by my own hesitation around difficulty labels, I created a browser extension that hides difficulty tags on LeetCode problems, enabling users to approach each challenge with an open mind.",
            keywords: ["Javascript"],
        },
        {
            hyperLink: "https://github.com/akashh369/reactmovieapp",
            link: "true",
            heading: "Movie App",
            description: "A movie web app that allows users to view top trending movies and web series, search for any movie, and watch its trailer",
            keywords: ["Reactjs"],
        },
    ]

    const navigate = useNavigate();
    return (
        <div className="main">
            <span className='section-title' id='about'> <i class="fa-solid fa-arrow-right"></i> About</span>
            <div className="about section" id="">
                <p>
                    As a <a href="" className='imp-text-style'>Full Stack Developer</a> with a strong passion for competitive programming, I am driven by the challenge of solving complex problems using efficient <a className='imp-text-style'>data structures and algorithms</a>.
                    My journey in technology began with a deep curiosity that led me to explore many aspects of software development. Over time, I have refined my skills in both <a className='imp-text-style'>front-end and back-end development</a>, enabling me to deliver robust and user-friendly solutions.
                </p>
                <p>
                    I have been working at <a href='https://inncircles.com/' className='imp-text-style'>Inncircles</a> for almost two years, gaining invaluable hands-on experience with real-world projects that require both technical expertise and creative problem-solving.
                </p>
                <p>
                    Outside of coding, I enjoy traveling and playing a variety of sports, with football and table tennis being my favorites.
                </p>
            </div>


            <span className='section-title' id='experience'> <i class="fa-solid fa-arrow-right"></i> Experience & Education</span>
            <div className="experience section" id="">
                {
                    experiences.slice(0, 4).map((item, i) => {
                        return (
                            <Card
                                date={item.date}
                                heading={item.heading}
                                role={item.role}
                                description={item.description}
                                keywords={item.keywords}
                            />
                        )
                    })
                }
                <a className='redirect-text-style' target='_blank' style={{ color: 'white' }} href='https://drive.google.com/file/d/1E4JOvqGDwnmp1EGHmW0euiUmWCdJCmuE/view'>
                    <span>
                        View Online Resume <i class="fa-solid fa-arrow-right"></i>
                    </span>

                </a>
            </div>

            <span className='section-title' id='skills'> <i class="fa-solid fa-arrow-right"></i>Skills</span>
            <div className="skills section" id="">
                <div className="skill-card">
                    <span className='skill-card-title'>Programming Languages</span>
                    <div className="skill-holder">
                        <div className="skill active">C/C++</div>
                        <div className="skill">Python</div>
                        <div className="skill">Java</div>
                    </div>
                </div>
                <div className="skill-card">
                    <span className='skill-card-title'>Frontend</span>
                    <div className="skill-holder">
                        <div className="skill">HTML & CSS</div>
                        <div className="skill active">Javascript</div>
                        <div className="skill">Typescript</div>
                        <div className="skill active">React Js</div>
                        <div className="skill">Angular Js</div>
                        <div className="skill active">React Native</div>
                    </div>
                </div>
                <div className="skill-card">
                    <span className='skill-card-title'>Backend</span>
                    <div className="skill-holder">
                        <div className="skill">Node Js</div>
                        <div className="skill active">Express Js</div>
                        <div className="skill ">Fastify</div>
                        <div className="skill ">NestJs</div>
                    </div>
                </div>
                <div className="skill-card">
                    <span className='skill-card-title'>Database</span>
                    <div className="skill-holder">
                        <div className="skill active">MongoDB</div>
                        <div className="skill">MySql</div>
                    </div>
                </div>
            </div>


            <span className='section-title' id='projects'> <i class="fa-solid fa-arrow-right"></i>Projects</span>
            <div className="projects section" id="">
                {
                    projects.slice(0, 4).map((item, i) => {
                        return (
                            <Link to={item.hyperLink} key={i}>
                                <Card
                                    logo={
                                        projectImages[i]
                                    }
                                    link={item.link}
                                    heading={item.heading}
                                    description={item.description}
                                    keywords={item.keywords}
                                />
                            </Link>
                        )
                    })
                }
                <span className='redirect-text-style' onClick={() => navigate('/projects')}>View All Projects <i class="fa-solid fa-arrow-right"></i></span>
            </div>
        </div>
    )
}

export default Main
